import { Modal } from "@circle-react-uikit/ModalV2";
import { OtpSignInPasswordForm } from "@circle-react/components/OnboardingPage/OtpSignInPage/OtpSignInPasswordForm";
import { OtpChallengeContent } from "@circle-react/components/OtpChallenge/OtpChallengeContent";
import type { Variant } from "@circle-react/contexts/OtpChallengeContext";

interface OtpChallengeModalProps {
  email?: string;
  error?: boolean | null;
  isLoading?: boolean;
  isOpen: boolean;
  isPasswordStep?: boolean;
  onCancel: () => void;
  onShowOtpForm?: () => void;
  onSignInWithPassword?: () => void;
  onSubmit: (otpCode: string) => void | Promise<void>;
  showSignInWithCode?: boolean;
  showSignInWithPassword?: boolean;
  variant: Variant;
}

export const OtpChallengeModal = ({
  isOpen,
  variant,
  email,
  onSubmit,
  onCancel,
  isLoading,
  error,
  showSignInWithPassword = false,
  onSignInWithPassword,
  isPasswordStep = false,
  onShowOtpForm,
  showSignInWithCode = true,
}: OtpChallengeModalProps) => {
  const isFullscreen = variant === "modal-fullscreen";

  return (
    <Modal shouldShowCloseButton isOpen={isOpen} className="!z-[2000]">
      <Modal.Overlay />
      <Modal.Content
        size={isFullscreen ? "screen" : "auto"}
        className={isFullscreen ? "" : "!h-auto !w-auto !rounded-lg"}
      >
        <Modal.Body className={isFullscreen ? "" : "!p-0"}>
          {isPasswordStep && email ? (
            <OtpSignInPasswordForm
              email={email}
              onShowOtpForm={onShowOtpForm ?? (() => undefined)}
              onCancel={onCancel}
              showSignInWithCode={showSignInWithCode}
              variant={variant}
            />
          ) : (
            <OtpChallengeContent
              email={email}
              isLoading={isLoading}
              error={error}
              onCancel={onCancel}
              onSubmit={onSubmit}
              showTitle={isFullscreen}
              showSubheaderTitle={!isFullscreen}
              includeBorder={isFullscreen}
              showSignInWithPassword={showSignInWithPassword}
              onSignInWithPassword={onSignInWithPassword}
            />
          )}
        </Modal.Body>
      </Modal.Content>
    </Modal>
  );
};

OtpChallengeModal.displayName = "OtpChallengeModal";
